import React from 'react';
import { Icon } from '@amzn/storm-ui-v3';
import { check, spinner } from '@amzn/storm-ui-icons-v3';
import styled from 'styled-components';

import { ErrorTooltip } from '@urc-ui/components/tooltips/error-tooltip';

interface Error {
  errorMessage: string;
}

/**
 * Most of these are props returned to us from redux query
 * errorMessage is passed when we want to show a specific string on error
 * example: if errorMessage for action is translated and we want to return the same one each time.
 * error is given to us from the rtk/api response
 * isLoading is a boolean. True when a request is in flight.
 * isError is a boolean. True when there was an error for a given request.
 * isSuccess is a boolean. True when a request was successful.
 */
interface QueryIconProps {
  readonly errorMessage?: string;
  readonly error?: Error;
  readonly isError?: boolean;
  readonly isSuccess?: boolean;
  readonly isLoading?: boolean;
}

const StyledIcon = styled(Icon)`
  color: ${({ theme }) => theme.palette.successGreen};
`;

export const QueryIcons = (props: QueryIconProps) => {
  const { isLoading, isSuccess, isError, error } = props;
  const errorMessage = props.errorMessage || (error?.errorMessage as string);
  return (
    <>
      {isLoading && <Icon type={spinner} />}
      {isSuccess && <StyledIcon type={check} />}
      {isError && <ErrorTooltip errorMessage={errorMessage} />}
    </>
  );
};
